import { z } from "zod";
import { zUid } from "./zUid";

export const zLinkInfoEntity = z.object({
  type: z.literal("ENTITY"),
  id: zUid,
  // Если указан bsId, то нужно открыть вкладку соответствующего бизнес-сервиса
  bsId: zUid.nullish(),
});

/**
 * Универсальное описание ссылки на страницы приложения
 */
export const zLinkInfo = z.discriminatedUnion("type", [zLinkInfoEntity]);
export type ZLinkInfo = z.infer<typeof zLinkInfo>;
